import React, { createContext, useContext } from "react";
import type {
  DistributionChannel,
  LodgingSortOrder,
} from "@b2bportal/lodging-api";
import {
  type AvailabilityConfig,
  defaultAvailabilityConfig,
} from "../features/availability/config";

export type HotelsConfig = {
  enableRoomSelection: boolean;
  enableMealPlans: boolean;
  availability: AvailabilityConfig;
  enableHomes: boolean;
  /** Distribution channels to send with homes availability/shop requests. */
  homesDistributionChannels?: DistributionChannel[];
  /** Filter out lodgings with available: false in the availability list. */
  filterUnavailableLodgings?: boolean;
  /** Sort order to use for availability requests. Defaults to MostRecommended. */
  availabilitySortOrder?: LodgingSortOrder;
  /** Show stay type filter (All stays, Hotels, Vacation rentals) on availability page. */
  enableStayTypeFilter?: boolean;
};

export const hotelsConfigContext = createContext<HotelsConfig | undefined>(
  undefined
);

export const defaultConfig = {
  availability: defaultAvailabilityConfig,
  enableRoomSelection: false,
  enableMealPlans: false,
  enableHomes: false,
  filterUnavailableLodgings: false,
  enableStayTypeFilter: false,
};

export const useHotelsConfig = () => {
  const portalConfig = useContext(hotelsConfigContext);
  if (!portalConfig) {
    return defaultConfig;
  }
  return portalConfig;
};

export interface HotelsConfigProviderProps {
  children: React.ReactNode;
  config: HotelsConfig;
}

export function HotelsConfigProvider({
  children,
  config,
}: HotelsConfigProviderProps) {
  return (
    <hotelsConfigContext.Provider value={config}>
      {children}
    </hotelsConfigContext.Provider>
  );
}
